/**
 * Room codes, case-insensitive (spec §2.9): generated ones are 6 chars without look-alikes; a host
 * may instead name the room with 3–6 of A–Z / 0–9, so any such string is a valid code.
 */
export const ROOM_CODE_ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
export const ROOM_CODE_LENGTH = 6;
export const ROOM_CODE_MIN = 3;
const ROOM_CODE_RE = new RegExp(`^[A-Z0-9]{${ROOM_CODE_MIN},${ROOM_CODE_LENGTH}}$`);

/** Uppercase + strip spaces/dashes. Uses the root locale so `i` → `I` (not Turkish `İ`). */
export function normalizeRoomCode(raw: string): string {
  return raw.replace(/[\s-]+/g, '').toUpperCase();
}

export function isValidRoomCode(raw: string): boolean {
  return ROOM_CODE_RE.test(normalizeRoomCode(raw));
}

/** Absolute invite link for a room. */
export function roomLink(code: string): string {
  return `${globalThis.location.origin}/r/${code}`;
}
